import React from "react";
import classes from "./Projects.module.css";
import { Box } from "@material-ui/core";
import Project from "./Project/Project";
import simpleShoppingImg from "../../asset/projects/simpleShopping.jpg";
import rgbGameImg from "../../asset/projects/rgbGame.png";
import twentyFourgameImg from "../../asset/projects/24game.jpg";
import palatableImg from "../../asset/projects/palatable.jpg";
import analyticHighlighterImg from "../../asset/projects/analyticHighlighter.png";
import compwellImg from "../../asset/projects/compwell.jpg";
import openstaxImg from "../../asset/projects/openstax.png";
import knowMyRisk from "../../asset/projects/knowMyRisk.png";

const projects = [
  {
    name: "Data Science Research Assistant",
    link: "https://compwell.rice.edu/",
    description:
      "Machine Learning is arguably the most exciting field in computer science today. The tremendous amount of progress made recently in deep learning keeps AI advancing its endless potentials. I was fortunate to become a member of Prof. Akane Sano's research group to tackle the problem of using ML to tell peopls's wellbeing condition. I implemented a GAN-based AutoEncoder architecture for missing data imputation with PyTorch, helped boosting wellbeing prediction accuracy.",
    title: "Rice University Computational Wellbeing Group",
    location: "Houston,TX,USA",
    img: compwellImg,
    date:"2020 Summer"
  },
  {
    name: "Content Development Intern",
    link: "https://openstax.org/",
    description:
      "As an educational initiative, OpenStax's mission is to give every student the tools they need to be successful in the classroom. OpenStax publishes high-quality, peer-reviewed, openly licensed college textbooks that are absolutely free online and low cost in print. I really agree with its mission and was lucky enough to be a part of the community to help provide millions of students worldwide free online educational resources. During the 15-week internship, I managed the content, errata revisions, and regression testing of 15 digital textbooks,improved textbooks quality and particiapted a team hacking!",
    title: "OpenStax",
    location: "Houston,TX,USA",
    img: openstaxImg,
    date:"2019 Summer"
  },
  {
    name: "Covid-19 Know My Risk",
    link:
      "https://devpost.com/software/covid19-rate-me",
    description:
      "During the pandemic, people, especially the youth, might be over-confident about their risk contracting COVID-19. On the other hand, those who are concerned might have difficulties gauging precisely their risk. Schools and workplaces might want to know whether some students/employees have high risks of COVID. Hence, our app tries to provide a way to easily and scientifically assess a person's level of concern regarding COVID-19.",
    title: "HackRice 10 Google Cloud Challenge Winner; React; Python Flask; RESTful API; Firebase; Logsitc Regression",
    location: "Houston,TX,USA",
    img: knowMyRisk,
    date:"Sept. 2020"
  },
  {
    name: "Analytic Highlighter",
    link:
      "https://chrome.google.com/webstore/detail/analytic-highlighter/gngfhmbddijbejbddcojohokhnblfina?hl=en",
    description:
      "Have you ever run into a long document and had no idea where to start reading? Have you had a hard time extracting key information from a research paper? Have you ever had trouble looking for answers to your questions on a web page? Maybe you want a magical tool that can extract key information for you? Let this chrome extension do for you! ",
    title: "HackRice 9 First Timer's Track Winner; Back End; Front End; RESTful API; NLP; ",
    location: "Houston,TX,USA",
    img: analyticHighlighterImg,
    date:"2019 - 2020"
  },
  {
    name: "Simple Shopping",
    link: "https://smart-sweet-shop.herokuapp.com/",
    description:
      "A mock for Amazon for practice purpose. A Full-Stacked MVC-structured shopping web application that supports common business logics for sellers and customers with NodeJS, Express, Stripe, and SendGrid. I deployed MongoDB to store users and products data, and JWT to temporarily cache user-sensitive data.",
    title: "Full-Stack; RESTful API; NodeJS; MongoDB; Authentication ",
    location: "Houston,TX,USA",
    img: simpleShoppingImg,
    date:"2020 Summer"
  },
  {
    name: "RGB Game",
    link: "https://yidi0213.github.io/RGBgame/",
    description:
      "Red, Green and Blue are the colors of colors since the combination of these big three give rise to every other colors. Thanks to R,G,B that we human beings are able to see the world in colorfulness. This is a game that you can hoan on your ability to recognize rgb color.",
    title: "Front End",
    location: "Houston,TX,USA",
    img: rgbGameImg,
    date:"2019"
  },
  {
    name: "24 Solver",
    link: "https://yidi0213.github.io/24Game/",
    description:
      "Can you solve a 24? The rule is simple. Given four numbers from 1 to 12, use plus, addition, multiplication and division among all four numbers to get 24. If it isn't chanllenging for you, can you solve it faster than a computer?",
    title: "Front End; React; Algorithm",
    location: "Houston,TX,USA",
    img: twentyFourgameImg,
    date:"2019"
  },
  {
    name: "Music Keyboard",
    link: "https://yidi0213.github.io/music-game/",
    description:
      "Your keyboard can do more than just typing, so can your pair of hands. It's time to transform the keyboard into a music instrument. Let's hit the key and make some music with your own creativity. See what pieces of music you can make!",
    title: "Front End; Audio; I/O",
    location: "Houston,TX,USA",
    img: palatableImg,
    date:"2019"
  },
];
const Projects = () => {
  return (
    <>
      <Box ml={4} my={4}>
        {<p className={classes.sectionName}>PORTFOLIO</p>}
        <hr></hr>
      </Box>
      {projects.map((info) => (
        <Project info={info} key={info.name} />
      ))}
    </>
  );
};

export default Projects;
